/*
 * @Author: zhouwei
 * @Date: 2019-11-07 10:11:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-08 15:32:39
 * @Desc: 基础数据模块
*/
<template>
  <div class="basic-data">
    <base-data
      :chart-data="chartData"
      :chart-options="chartOptions"
      :base-data="baseInfoData"
      @dateChange="dateChange"
    ></base-data>
  </div>
</template>
<script>
import baseData from '../../../../statistical-data/basic-data/base.vue'
import { BIZAPIS } from '@api'
export default {
  components: {
    baseData
  },
  data () {
    return {
      chartData: [],
      chartOptions: {
        chart: {
          height: 400,
          padding: [50, 50, 50, 50],
          scale: {
            time: {
              tickCount: 12 // 显示<=12的所有数据
            }
          }
        },
        axis: [
          {
            name: 'time'
          },
          {
            name: 'attachCount'
          }
        ],
        geom: [
          {
            type: 'point',
            position: 'time*attachCount', // 对于数据的year,value
            color: 'type' // 对于数据的city
          },
          {
            type: 'line',
            position: 'time*attachCount',
            color: 'type'
          }
        ]
      },
      baseInfoData: {
        visits: 0, // 访问量（P）
        visitors: 0, // 访问线索（UV）
        coverWxFriend: 0, // 覆盖微信好友数量
        addClue: 0, // 新增线索数
        forward: 0 // 转发数
      }
    }
  },
  created () {
    this.getBaseData()
    this.getMapData('day') // 默认获取日
  },
  methods: {
    dateChange (e) {
      let arr = ['日', '周', '月']
      let obj = {
        day: '日',
        week: '周',
        month: '月'
      }
      for (let s in obj) {
        if (e === obj[s]) {
          this.getMapData(s)
        }
      }
    },
    async getBaseData () {
      // 获取基础数据
      const res = await BIZAPIS.StatisticsApi.timingPlanStatisticsOverviewGet({
        planId: this.$route.query.id
      })
      if (res.success) {
        let data = res.data
        this.baseInfoData = {
          visits: data.pv,
          visitors: data.uv,
          coverWxFriend: data.wxContact,
          addClue: data.newClue,
          forward: data.forward
        }
      }
    },
    async getMapData (type) {
      const res = await BIZAPIS.StatisticsApi.timingPlanStatisticsLineChartGet({
        statisticsType: type,
        planId: this.$route.query.id
      })
      if (res.success) {
        this.chartData = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.basic-data {
  // width: calc(100% - 40px);
  margin: 0 auto;
}
</style>
